<div
  #container
  [style.background-image]="'url(/assets/images/route-planning/background.png)'"
  class="route-planner bg-no-repeat bg-contain h-full max-h-full overflow-y-hidden"
  [ngClass]="{ 'route-planner--mobile': !!isMobile,  }"
  >
  <!-- change icon to "bars" to enable hamburger menu -->
  <app-route-planner-header
    [icon]="'bars'"
    [hideInDesktop]="true"
    [showLogo]="true"
    [backButtonAriaLabel]="openSideMenuAriaLabel"
    (onHeaderButtonClick)="setOpenMenu(true)"
    [title]="title"
    />

    <div
      class="tabs-wrapper relative px-[0.8125rem] flex flex-col"
    [ngClass]="{
      'tabs-wrapper--desktop': !isMobile,
      'tabs-wrapper--mobile': !!isMobile
    }"
      >
      <div
        class="custom-tabs flex-1 overflow-y-auto"
        [ngClass]="{ 'pt-6': !isMobile }"
        [dir]="direction"
        style="height: calc(100% - 3.75rem)"
        >
        <!-- Tab header (WAI-ARIA Tabs pattern with roving tabindex on tabs only) -->
        <div class="custom-tab-header">
          <button
            type="button"
            class="custom-tab-arrow custom-tab-arrow--before"
            [disabled]="selectedTabIndex === 0"
            (click)="onPrevTab()"
            aria-label="Previous tab"
            >
            <span class="custom-tab-arrow-chevron"></span>
          </button>

          <div
            class="custom-tab-labels"
            role="tablist"
            (keydown)="onTablistKeydown($event)"
            #tabLabelsContainer
            >
            @for (label of tabLabels; track $index) {
              <button
                type="button"
                class="custom-tab-label"
                role="tab"
                [class.custom-tab-label--active]="selectedTabIndex === $index"
                [attr.aria-selected]="selectedTabIndex === $index"
                [attr.tabindex]="focusedTablistIndex === $index ? '0' : '-1'"
                (click)="selectTab($index)"
                (focus)="focusedTablistIndex = $index"
                #tabLabelBtn
                >
                {{ label }}
              </button>
            }
          </div>

          <button
            type="button"
            class="custom-tab-arrow custom-tab-arrow--after"
            [disabled]="selectedTabIndex === tabLabels.length - 1"
            (click)="onNextTab()"
            aria-label="Next tab"
            >
            <span class="custom-tab-arrow-chevron"></span>
          </button>
        </div>

        <!-- Tab body -->
        <div class="custom-tab-body" [@tabSlide]="selectedTabIndex">
          @switch (selectedTabIndex) {
            @case (0) {
              <app-source-destination-form
                #form
                #sourceDestinationForm
                (toggleSearchButton)="this.isSearchButtonDisabled = $event"
                (toogleLoader)="this.isShowLoader = $event"
              ></app-source-destination-form>
            }
            @case (1) {
              <app-search-line-form
                #form
                #searchLineForm
                (toggleSearchButton)="this.isSearchButtonDisabled = $event"
                (toogleLoader)="this.isShowLoader = $event"
              ></app-search-line-form>
            }
            @case (2) {
              <app-search-station-form
                #form
                #searchStationForm
                (toggleSearchButton)="this.isSearchButtonDisabled = $event"
                (toogleLoader)="this.isShowLoader = $event"
              ></app-search-station-form>
            }
            @case (3) {
              <app-lines-between-cities-form
                #form
                #linesBetweenCitiesForm
                (toggleSearchButton)="this.isSearchButtonDisabled = $event"
                (toogleLoader)="this.isShowLoader = $event"
              ></app-lines-between-cities-form>
            }
            @case (4) {
              <app-car-integrated-form
                #form
                #carIntegratedForm
                (toggleSearchButton)="this.isSearchButtonDisabled = $event"
                (toogleLoader)="this.isShowLoader = $event"
              ></app-car-integrated-form>
            }
          }
        </div>
      </div>

      @if (!!activeForm) {
        <div
          class="sticky bottom-0 pt-3 pb-1 z-50 bg-transparent"
          style="height: 3.75rem"
          >
          <!--
            a11y / regression: button must be type="button", not type="submit".
            It is rendered OUTSIDE the per-tab <form [formGroup]> (the form lives
            inside mat-tab, the button is a sibling sticky footer), but mobile
            users / SR users pressing Enter or the on-screen keyboard "Search"
            key from inside a combobox triggered the form's implicit submission,
            and because the form had no (ngSubmit) handler the browser did the
            default GET submission and reloaded the page. After the reload, the
            init address-map overlay re-opens (set up in
            RoutePlanningContainerComponent.ngAfterViewInit) and its header H2
            "Search Address" is the first heading in the DOM, which is exactly
            the symptom the audit reported. The (ngSubmit) on each form
            additionally prevents the default reload; this type="button"
            change makes the click path explicit and decoupled from form
            submission semantics.
          -->
          <mot-button
        [disabled]="
          !activeForm.routePlannerForm.valid || isSearchButtonDisabled
        "
            (onClick)="activeForm.submitRoutePlannerForm()"
            buttonClass="not-disabled:!bg-primary w-full !text-white !py-6 !rounded-lg !align-middle disabled:!text-[#B4BFCB]"
            [text]="activeForm.buttonTitle"
            type="button"
            />
          </div>
        }
      </div>
      @if (isShowLoader) {
        <app-loader />
      }
      @if (openMenu) {
        <app-side-menu
          [isOpen]="openMenu"
          (close)="setOpenMenu(false)"
          (openContact)="onSideMenuOpenContact()"
          />
      }
      <app-contact-view
        [isOpen]="isContactOpen"
        [contactInfo]="contactInfo"
        (close)="onMinistryContactClose()"
        />
      </div>
